import { render, staticRenderFns } from "./CarouselRatings.vue?vue&type=template&id=02a4767a&"
import script from "./CarouselRatings.vue?vue&type=script&lang=js&"
export * from "./CarouselRatings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports